import MainLayout from "../components/layouts/main/MainLayout";
import MainContent from "../components/main/MainContent";
export default function HomePage() {

    return (
        <MainLayout>
            <MainContent />
        </MainLayout>
    )
}